<template>
  <div
    v-if="setorSelecionadoExecutaManutencaoOuCalibracao"
    class="progress-bar-container"
  >
    <div class="progress-bar-header">Meta diária: {{ progressoFormatado }}</div>
    <div class="progress-bar">
      <div
        class="progress-bar-fill"
        :style="{ width: `${percentual}%`, backgroundColor: '#039855' }"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    setorSelecionadoExecutaManutencaoOuCalibracao: {
      type: Boolean,
      default: true,
    },
    dadosKanban: { type: Object, default: () => {} },
  },
  data() {
    return {
      osProgramadas: 0,
      osFinalizadas: 0,
    };
  },
  computed: {
    percentual() {
      if (!this.osProgramadas || this.osProgramadas === 0) {
        return 0;
      }
      return Math.min(
        Math.round((this.osProgramadas / this.osFinalizadas) * 100),
        100
      );
    },
    progressoFormatado() {
      return `${this.percentual}% (${this.osProgramadas}/${this.osFinalizadas})`;
    },
  },
  mounted() {
    this.osProgramadas = this.dadosKanban.quantidadeFinalizadosDia;
    this.osFinalizadas = this.dadosKanban.quantidadePlanejadosDia;
  },
};
</script>

<style scoped>
.progress-bar-container {
  background-color: #35507b;
  width: 350px;
  color: #ffffff;
}

.progress-bar-header {
  font-size: 14px;
  margin-bottom: 5px;
}

.progress-bar {
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  transition: width 0.3s ease;
}
</style>
